
























































































































import * as memberAPI from '@adobe/edex/frontend/api/member';
import Products from '@adobe/edex/frontend/components/common/products.vue';
import Subjects from '@adobe/edex/frontend/components/common/subjects.vue';
import Certifications from '@adobe/edex/frontend/components/common/certifications.vue';

import { mapState } from 'vuex';
import { getParentSubjects } from '@adobe/edex/ui/shared/frontend/utils';
import { getCourseURL } from '@adobe/edex/ui/shared/utils/routes';

export default {
  props: ['profile'],
  components: {
    Products,
    Subjects,
    Certifications,
    Multiselect: () =>
      import(/* webpackChunkName: "externals" */ 'vue-multiselect').then(
        ({ Multiselect }) => Multiselect
      ),
  },
  data() {
    return {
      editMode: false,
      loading: false,
      formData: this.getFormData(),
    };
  },
  computed: {
    ...mapState('member', ['member']),
    showProducts() {
      return this.profile.expertise.products.length || this.editMode;
    },
    subjects() {
      return getParentSubjects(this.profile.expertise.subjects);
    },
    showSubjects() {
      return this.subjects.length || this.editMode;
    },
    showCertifications() {
      return this.profile.expertise.certifications.length || this.editMode;
    },
    showSkills() {
      return this.profile.expertise.skills.length || this.editMode;
    },
    showCourseBadges() {
      return this.courseBadges.length;
    },
    showExpertise() {
      return (
        this.showProducts ||
        this.showSubjects ||
        this.showCertifications ||
        this.showSkills ||
        this.showCourseBadges
      );
    },
    courseBadges() {
      return this.profile.badgesByCategory['i18n.badge.course'] || [];
    },
    canEdit() {
      return this.profile.id === this.member?.id;
    },
  },
  methods: {
    getCourseURL,
    getFormData() {
      const {
        products,
        subjects,
        certifications,
        skills,
      } = this.profile.expertise;
      return {
        products: products.map(({ id }) => id),
        subjects: subjects.map(({ id }) => id),
        certifications: certifications.map(({ id }) => id),
        skills,
      };
    },
    onEdit() {
      this.editMode = !this.editMode;
    },
    onCancel() {
      this.formData = this.getFormData();
      this.editMode = false;
    },
    async onUpdate() {
      await this.updateExpertise();
      this.editMode = false;
    },
    onChangeProducts(products) {
      this.formData.products = products;
    },
    onChangeSubjects(subjects) {
      this.formData.subjects = subjects;
    },
    onChangeCertifications(certifications) {
      this.formData.certifications = certifications;
    },
    addSkill(value) {
      this.formData.skills.push(value);
      this.formData.skills = [...new Set(this.formData.skills)];
    },
    async updateExpertise() {
      this.loading = true;
      const { products, subjects, certifications, skills } = this.formData;
      const { status, data: profile } = await memberAPI.updateSelfExpertise({
        products,
        subjects,
        certifications,
        skills,
      });
      if (status === 200) {
        this.$emit('updated', profile);
      }
      this.loading = false;
    },
  },
};
